import Result from 'antd/es/result';
import { withConfigProvider } from '../config-provider';
export { IconMap, ExceptionMap } from 'antd/es/result';
export default withConfigProvider(Result);
